import React from 'react'
import FAQHeader from './Components/FAQ-header'
import PricingBox1 from './Components/Pricing-box1'
// import CompanyLogoSlider from './Components/COmpany-logo-slider';
import PricingBox2 from './Components/Pricing-box2'
// import PricingQNA from './Components/Pricing-QNA';
import HomeBox13 from './Components/Home-box13';

function Pricing() {
    return (
        <>
            <FAQHeader />
            <PricingBox1 />
            {/* <CompanyLogoSlider /> */}
            <PricingBox2 />
            {/* <PricingQNA /> */}
            <HomeBox13 />
        </>
    )
}

export default Pricing